import { useSelector } from 'react-redux';
import { State } from 'store/store';
import semver from 'semver';

export const useModuleVersionOnCreation = () => {
  const moduleVersionOnCreation = useSelector((state: State) => {
    return (
      state.rootBlockId &&
      (state.blocks[state.rootBlockId]?.meta as any)?.versionOnCreation
    );
  });

  //
  return moduleVersionOnCreation || '0.0.0';
};

export const useCompareModuleVersionOnCreationWith = (
  moduleVersion: string
): boolean => {
  //

  return semver.gte(useModuleVersionOnCreation(), moduleVersion);
};
